/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveDeckExerciseDTO
 */
export interface RemoveDeckExerciseDTO {
    /**
     * 
     * @type {string}
     * @memberof RemoveDeckExerciseDTO
     */
    deckId: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveDeckExerciseDTO
     */
    exerciseId: string;
}

/**
 * Check if a given object implements the RemoveDeckExerciseDTO interface.
 */
export function instanceOfRemoveDeckExerciseDTO(value: object): value is RemoveDeckExerciseDTO {
    if (!('deckId' in value) || value['deckId'] === undefined) return false;
    if (!('exerciseId' in value) || value['exerciseId'] === undefined) return false;
    return true;
}

export function RemoveDeckExerciseDTOFromJSON(json: any): RemoveDeckExerciseDTO {
    return RemoveDeckExerciseDTOFromJSONTyped(json, false);
}

export function RemoveDeckExerciseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveDeckExerciseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'deckId': json['deckId'],
        'exerciseId': json['exerciseId'],
    };
}

export function RemoveDeckExerciseDTOToJSON(json: any): RemoveDeckExerciseDTO {
    return RemoveDeckExerciseDTOToJSONTyped(json, false);
}

export function RemoveDeckExerciseDTOToJSONTyped(value?: RemoveDeckExerciseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deckId': value['deckId'],
        'exerciseId': value['exerciseId'],
    };
}

